
import { groupsCollapsedFacet, allGroupsCollapsedFacet } from '../facets/ScopeFacets';
import { IGroup } from 'office-ui-fabric-react/lib/DetailsList';
import { createAsyncActionCreator, IDispatch, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { IFaceted } from '../models/Facet';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { resolveItems } from './getItems';

export const toggleCollapseAll = createAsyncActionCreator((payload: {
  itemsScopeItemKey: string;
  newAllCollapsed: boolean;
  groups: IGroup[];
}): IItemCacheThunkAction<void> => {
  let {
    itemsScopeItemKey,
    newAllCollapsed,
    groups
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    let groupsCollapsed: typeof groupsCollapsedFacet.type = {};
    for (let group of groups) {
      if (group.key.indexOf('groupPage-') === -1) {
        groupsCollapsed[group.key] = newAllCollapsed;
      }
      if (group.children) {
        for (let child of group.children) {
          groupsCollapsed[child.key] = newAllCollapsed;
        }
      }
    }

    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: {
          ...groupsCollapsedFacet.pack(groupsCollapsed),
          ...allGroupsCollapsedFacet.pack(newAllCollapsed)
        }
      }
    }));
  };
});

// @ts-ignore
type __unused_declarations = Pick<
  IDispatch<never> |
  IAsyncActionCreator<never, never> |
  IFaceted |
  IItemCacheState,
  never>;
